import { Dropdown, Menu, Modal, Select, Switch, Typography } from "antd";
import {
  SortAscendingOutlined,
  SortDescendingOutlined,
} from "@ant-design/icons";
import { saveAs } from "file-saver";
import json2csv from "json2csv";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  AnalyticsCardsExport,
  analytics_cards,
  analytics_cards_all,
} from "../../actions/cards/cards";
import cross from "../../assets/icons/cross_filled.svg";
import more from "../../assets/icons/more.png";
import file from "../../assets/images/file.png";
import { amountFormat } from "../../utils";
import FilterInputs from "./FilterInputs";
import { getSymbol } from "../../config/helper";

const { Title } = Typography;

const expense_keys = [
  {
    label: "Transaction ID",
    value: "transaction_number",
    type: "string",
  },
  {
    label: "Category",
    value: "category",
    type: "string",
  },
  {
    label: "Report ID",
    type: "string",
    value: "report_number",
  },
  {
    label: "Report Name",
    type: "string",
    value: "report_name",
  },
  {
    label: "Submitted On",
    value: "report_submitted_on",
    type: "date",
  },
  {
    label: "Amount",
    value: "transaction_amount",
    type: "number",
  },
  {
    label: "Project",
    value: "project",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
  {
    label: "Transaction Date",
    value: "transaction_date",
    type: "date",
  },
];

const card_keys = [
  {
    label: "Employee ID",
    value: "employee_ids",
    type: "string",
  },
  {
    label: "CRN",
    value: "card_reference_numbers",
    type: "string",
  },
  {
    label: "Employee Name",
    value: "employee_names",
    type: "string",
  },
  {
    label: "Transaction ID",
    value: "transaction_id",
    type: "string",
  },
  {
    label: "Transaction Date",
    value: "transaction_date",
    type: "date",
  },
  {
    label: "Merchant Name",
    value: "merchant",
    type: "string",
  },

  {
    label: "Transaction Amount",
    value: "transaction_amount",
    type: "number",
  },
  {
    label: "Wallet name",
    value: "wallet_name",
    type: "string",
  },
  {
    label: "Merchant MCC",
    value: "merchant_mcc",
    type: "string",
  },
  {
    label: "Transaction Type",
    value: "transaction_type",
    type: "select",
    values: [
      { label: "Credit", value: "Cr" },
      { label: "Debit", value: "Dr" },
    ],
  },
  {
    label: "Approval Status",
    value: "status",
    type: "select",
    values: [{ label: "Pending", value: "pending_approval" }],
  },
  {
    label: "Project",
    value: "project",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
];

const report_keys = [
  {
    label: "Report ID",
    value: "report_id",
    type: "string",
  },
  {
    label: "Report Name",
    value: "report_names",
    type: "string",
  },
  {
    label: "Employee Name",
    value: "employee_name",
    type: "string",
  },
  {
    label: "Start Date",
    value: "start_date",
    type: "date",
  },
  {
    label: "End Date",
    value: "end_date",
    type: "date",
  },
  {
    label: "Submitted On",
    value: "submitted_on",
    type: "date",
  },

  {
    label: "Amount",
    value: "total_amount",
    type: "number",
  },

  {
    label: "Status",
    value: "status",
    type: "select",
    values: [{ label: "Pending", value: "pending_approval" }],
  },
  {
    label: "Project",
    value: "project",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
];

const advance_keys = [
  {
    label: "Advance ID",
    value: "advance_ids",
    type: "string",
  },
  {
    label: "Purpose or Title",
    value: "titles",
    type: "string",
  },
  {
    label: "Date & Time",
    value: "created_at",
    type: "date",
  },
  {
    label: "Reference",
    value: "reference_numbers",
    type: "string",
  },
  {
    label: "Amount",
    value: "amount",
    type: "number",
  },

  {
    label: "Status",
    value: "status",
    type: "select",
    values: [
      { label: "Pending", value: "pending_approval" },
      { label: "Recovered", value: "recovered" },
    ],
  },
  {
    label: "Project",
    value: "project",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
];

const trip_keys = [
  {
    label: "Trip ID",
    value: "trip_number",
    type: "string",
  },
  {
    label: "Title",
    value: "title",
    type: "string",
  },
  {
    label: "Employee Name",
    value: "employee_names",
    type: "string",
  },
  {
    label: "Purpose",
    value: "purpose",
    type: "string",
  },
  {
    label: "Submitted On",
    value: "submitted_on",
    type: "date",
  },
  {
    label: "Status",
    value: "status",
    type: "select",
    values: [{ label: "Pending", value: "pending_approval" }],
  },
  {
    label: "Project",
    value: "project",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
];

const Reports = ({
  setShowGraph,
  setFilterObj,
  filters,
  apiFilters,
  setFilters,
  pdfURL,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [keys, setKeys] = useState([]);
  const [from, setFrom] = useState("summary");
  const [selectedVals, setSelectedVals] = useState([1]);
  const [selectedType, setSelectedType] = useState({});
  const [selectedFil, setSelectedFil] = useState({});
  const [selectExport, setSelectExport] = useState(null);
  const [sortOrder, setSortOrder] = useState({});
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const cards_export = useSelector(
    (state) => state.analytics.analytics_cards_export
  );
  const cards = useSelector((state) => state.analytics.analytics_cards || {});
  const pdfData = useSelector((state) => state.analytics.analytics_cards_all);

  // const [exportOptions] = useExport(cards_export);
  useEffect(() => {
    if (cards?.success) {
      setIsModalVisible(false);
    }
  }, [cards]);

  useEffect(() => {
    if (Object.keys(filters).length === 0) {
      setSelectedVals([1]);
      setSelectedFil({});
      setSelectedType({});
    }
  }, [filters]);

  useEffect(() => {
    return () => {
      dispatch({
        type: AnalyticsCardsExport.RESET,
      });
    };
    // eslint-disable-next-line
  }, []);
  const labels = {
    summary: {
      a: "Total Spend",
      b: "Cards",
      c: "Reimbursements",
      d: "Pending Reimbursements",
    },
    cards: {
      a: "Total Transaction Amount",
      b: "Available Balance on Cards",
      c: "Reported",
      d: "Unreported",
    },
  };

  const handleCancel = () => {
    setFilterObj({});
    setSelectedType({});
    setSelectedVals([1]);
    setSelectedFil({});
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (location?.pathname?.includes("cards")) {
      setFrom("cards");
      setKeys(card_keys);
    }

    if (location?.pathname?.includes("reports")) setKeys(report_keys);
    if (location?.pathname?.includes("advances")) setKeys(advance_keys);
    if (location?.pathname?.includes("trips")) setKeys(trip_keys);
    if (location?.pathname?.includes("expenses")) setKeys(expense_keys);
    setSelectExport(null);
    // eslint-disable-next-line
  }, [location.pathname]);

  const getKeys = (index) => {
    let cKeys = [];
    if (index - 1 !== selectedFil?.[index]?.[1]) {
      cKeys = keys.filter(
        (ele) =>
          !Object.values(selectedFil)
            .map((ele) => ele[0])
            .includes(ele.value)
      );
    } else {
      cKeys = keys.filter(
        (ele) =>
          !Object.values(selectedFil)
            .map((ele) => ele[0])
            .includes(ele.value)
      );
      let cKey = keys.find((ele) => selectedFil?.[index]?.[0] === ele.value);
      if (cKey) cKeys.push(cKey);
    }
    return cKeys;
  };
  const dotMenu = {
    reports: ["employee_name", "from_date", "to_date", "report_name"],
    advances: ["amount", "title"],
    cards: ["amount", "employee_name"],
    expenses: ["amount", "transaction_date", "employee_name", "merchant_name"],
    trips: ["employee_name", "trip_name", "submitted_on", "purpose"],
  };
  return (
    <div className="reports">
      {/*
      <div className="flex-between heading">
         <span>
          {location?.pathname?.includes("cards") && "Card Transactions"}
          {location?.pathname?.includes("reports") && "Expense reports"}
          {location?.pathname?.includes("advances") && "Advances"}
        </span>
        <span>
           <span>Schedule Report</span> 
           <span>Print</span> 
        </span>
      </div>
         */}

      <div className="w100">
        <div className="flex-between m1">
          <div>
            {/* <Select
              placeholder={"Report Date"}
              options={[
                {
                  label: "This month",
                  value: "This month",
                },
              ]}
            /> */}
            <span
              className="customize ml1"
              onClick={() => setIsModalVisible(true)}
            >
              Customize
            </span>
          </div>
          <div
            className="d-flex"
            style={{
              alignItems: "center",
            }}
          >
            {!location?.pathname?.includes("reports") &&
              !location?.pathname?.includes("cards") &&
              !location?.pathname?.includes("trips") &&
              !location?.pathname?.includes("expenses") &&
              !location?.pathname?.includes("advances") && (
                <div className="mr2">
                  <label className="mr1">Show Graph</label>
                  <Switch
                    className="switch"
                    onChange={(e) => {
                      setShowGraph(e);
                    }}
                  />
                </div>
              )}
            <div className="mr1">
              <Select
                placeholder="Export as"
                options={
                  cards_export?.loading
                    ? []
                    : [
                        {
                          label: "PDF",
                          value: "PDF",
                        },
                        {
                          label: "CSV",
                          value: "CSV",
                        },
                      ]
                }
                value={selectExport}
                allowClear
                notFoundContent={cards_export?.loading ? "Loading..." : ""}
                onChange={(e) => {
                  if (
                    pdfData?.data?.response?.[
                      location?.pathname?.includes("reports")
                        ? "report"
                        : location?.pathname?.includes("cards") ||
                          location?.pathname?.includes("expenses")
                        ? "transaction"
                        : location?.pathname?.includes("trips")
                        ? "trip"
                        : "report"
                    ]?.length > 0
                  ) {
                    let prods =
                      pdfData?.data?.response?.[
                        location?.pathname?.includes("reports")
                          ? "report"
                          : location?.pathname?.includes("cards") ||
                            location?.pathname?.includes("expenses")
                          ? "transaction"
                          : location?.pathname?.includes("trips")
                          ? "trip"
                          : "report"
                      ];
                    let prods1 = prods?.map((ele) => {
                      let obj = {};
                      ele?.custom_fields?.forEach((ele) => {
                        obj = { ...obj, [ele?.key]: ele?.value };
                      });
                      let obj2 = JSON.parse(
                        JSON.stringify({
                          ...ele,
                          ...obj,
                        })
                      );
                      delete obj2.custom_fields;
                      return obj2;
                    });
                    setSelectExport(e);
                    if (e === "CSV") {
                      const formattedData = prods1.map((item) => ({
    "Card number": item?.card_number || "-",
    "CRN": item?.card_reference_no || "-",
    "Employee ID": item?.employee_details?.employee_id || "-",
    "Employee Name": item?.employee_details?.name || "-",
    "Email": item?.employee_details?.email || "-",
    "Balance": item?.balance
      ? getSymbol() + " " + amountFormat(item.balance)
      : "-",
    "Activated On": item?.card_activated_on || "-",
    "Status": item?.status || "-",
    "KYC Status": item?.kyc_flag || "-",
  }));
                      let filename = location?.pathname?.includes("reports")
                        ? "MISExpenseReports"
                        : location?.pathname?.includes("cards")
                        ? "MISCards"
                        : location?.pathname?.includes("expenses")
                        ? "MISExpense"
                        : location?.pathname?.includes("trips")
                        ? "MISTrips"
                        : "MISAdvances";
                      let csv = json2csv.parse(prods1);
                      var blob = new Blob([csv], {
                        type: "text/csv;charset=utf-8",
                      });
                      saveAs(blob, `${filename}.csv`);
                    } else if (e === "PDF") {
                      pdfURL?.current?.();
                    }
                  }
                }}
              />
            </div>
            <div>
              <Dropdown
                overlay={
                  <Menu>
                    {/* <label className="dim-text ml1">Sort By</label> */}
                    {dotMenu?.[
                      location?.pathname?.includes("reports")
                        ? "reports"
                        : location?.pathname?.includes("expenses")
                        ? "expenses"
                        : location?.pathname?.includes("trips")
                        ? "trips"
                        : location?.pathname?.includes("cards")
                        ? "cards"
                        : "advances"
                    ]?.map((ele, i) => (
                      <Menu.Item key={i}>
                        <button
                          className="tableFilter"
                          onClick={() => {
                            let sortKey = ele;
                            let type = "";

                            if (location?.pathname?.includes("reports")) {
                              type = "reports";
                            } else if (location?.pathname?.includes("trips")) {
                              type = "trips";
                              if (sortKey === "purpose")
                                sortKey = "destination";
                            } else if (
                              location?.pathname?.includes("expenses")
                            ) {
                              type = "expenses";
                            } else if (location?.pathname?.includes("cards")) {
                              type = "cards";
                            } else if (
                              location?.pathname?.includes("advances")
                            ) {
                              type = "advances";
                            }
                            const normalizeFilters = (src) => {
                              const copy = { ...(src || {}) };
                              Object.keys(copy).forEach((k) => {
                                if (Array.isArray(copy[k]))
                                  copy[k] = copy[k].join(",");
                              });
                              return copy;
                            };

                            const filtersForDispatch =
                              normalizeFilters(filters);
                            const apiFiltersForSet =
                              normalizeFilters(apiFilters);

                            if (type) {
                              dispatch(
                                analytics_cards({
                                  ...filtersForDispatch,
                                  type,
                                  sort_key: sortKey,
                                  sort_order: sortOrder[sortKey]
                                    ? "dsc"
                                    : "asc",
                                })
                              );
                              dispatch(
                                analytics_cards_all({
                                  ...apiFiltersForSet,
                                  type,
                                  sort_key: sortKey,
                                  sort_order: sortOrder[sortKey]
                                    ? "dsc"
                                    : "asc",
                                  csv: true,
                                })
                              );
                            }

                            setFilters({
                              ...apiFiltersForSet,
                              sort_key: sortKey,
                              sort_order: sortOrder[sortKey] ? "dsc" : "asc",
                            });
                            setSortOrder({
                              [sortKey]: !sortOrder[sortKey],
                            });
                          }}
                        >
                          <span style={{ textTransform: "capitalize" }}>
                            {ele?.replace("_", " ")}{" "}
                            {apiFilters.sort_key === ele &&
                              !sortOrder[apiFilters.sort_key] && (
                                <SortDescendingOutlined />
                              )}
                            {apiFilters.sort_key === ele &&
                              sortOrder[apiFilters.sort_key] && (
                                <SortAscendingOutlined />
                              )}
                          </span>
                        </button>
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <button className="more reports">Sort by</button>
              </Dropdown>
            </div>
          </div>
        </div>
        {Object.keys(filters).length > 0 && !isModalVisible && (
          <div className="ml2">
            <div
              className="filterAppliedContainer d-flex spacing mt1 mb1"
              style={{
                alignItems: "center",
              }}
            >
              <div className="filterBlock">
                <span className="filterTxt">Filters applied :</span>
                {Object.keys(filters).map((ele) => (
                  <span className="filterBtn">
                    <span className="filterItem capitalize">
                      {ele.replace(/_/g, " ")} -{" "}
                      {Array.isArray(filters[ele])
                        ? filters[ele]?.join(", ")
                        : filters[ele]}
                    </span>
                    <img
                      src={cross}
                      alt="cross"
                      onClick={() => {
                        let obj = { ...filters };
                        delete obj[ele];
                        // Convert array values to comma-separated strings
                        Object.keys(obj).forEach((key) => {
                          if (Array.isArray(obj[key])) {
                            obj[key] = obj[key].join(",");
                          }
                        });
                        setFilterObj(obj);
                        let otherObj = {};
                        if (location.pathname?.includes("cards")) {
                          otherObj.card_only = true;
                        }
                        dispatch(
                          analytics_cards({
                            ...obj,
                            ...otherObj,
                            type: location.pathname?.includes("expenses")
                              ? "expenses"
                              : location.pathname?.includes("trips")
                              ? "trips"
                              : location.pathname?.includes("reports")
                              ? "reports"
                              : location.pathname.includes("advances")
                              ? "advances"
                              : "cards",
                          })
                        );
                        dispatch(
                          analytics_cards_all({
                            ...obj,
                            ...otherObj,
                            type: location.pathname?.includes("expenses")
                              ? "expenses"
                              : location.pathname?.includes("trips")
                              ? "trips"
                              : location.pathname?.includes("reports")
                              ? "reports"
                              : location.pathname.includes("advances")
                              ? "advances"
                              : "cards",
                            csv: true,
                          })
                        );
                        setSelectExport(null);
                      }}
                    />
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      {!location?.pathname?.includes("reports") &&
        !location?.pathname?.includes("cards") &&
        !location?.pathname?.includes("trips") &&
        !location?.pathname?.includes("expenses") &&
        !location?.pathname?.includes("advances") && (
          <div className="p1 pl4 d-flex">
            <div className="v-center w25">
              <img src={file} alt="file" width={20} height={24} />
              <div className="spend-card">
                <span className="title">{labels[from]?.a}</span>
                <span className="amt">INR {amountFormat(66900)}</span>
                <span className="sub">{`(1400 Expenses)`}</span>
              </div>
            </div>
            <div className="v-center w25">
              <img src={file} alt="file" width={20} height={24} />
              <div className="spend-card">
                <span className="title">{labels[from]?.b}</span>
                <span className="amt">INR {amountFormat(95000)}</span>
                <span className="sub">{`(1400 Expenses)`}</span>
              </div>
            </div>
            <div className="v-center w25">
              <img src={file} alt="file" width={20} height={24} />
              <div className="spend-card">
                <span className="title">{labels[from]?.c}</span>
                <span className="amt">INR {amountFormat(150268)}</span>
                <span className="sub">{`(1400 Expenses)`}</span>
              </div>
            </div>
            <div className="v-center w25">
              <img src={file} alt="file" width={20} height={24} />
              <div className="spend-card">
                <span className="title">{labels[from]?.d}</span>
                <span className="amt">INR {amountFormat(52132)}</span>
                <span className="sub">{`(1400 Expenses)`}</span>
              </div>
            </div>
          </div>
        )}
      <Modal
        title={
          <Title level={4}>
            Customize&nbsp;
            <span className="text-small">
              {location?.pathname?.includes("reports")
                ? "Expense reports"
                : location?.pathname?.includes("expenses")
                ? "Expenses"
                : location?.pathname?.includes("trips")
                ? "Trips"
                : location?.pathname?.includes("cards")
                ? "Card Transactions"
                : "Advances"}
            </span>
          </Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className="right-alinged-modal customized-wrap"
      >
        <div className="mb2 flex-between">
          <div>
            <button className="filter-btn active mr1">Filters</button>
            {/* <button className="filter-btn">Show/Hide Columns</button> */}
          </div>
          <div>
            <span
              className="customize"
              onClick={() => {
                setFilterObj({});
                setSelectedType({});
                setSelectedVals([1]);
                setSelectedFil({});
              }}
            >
              Reset Filters
            </span>
          </div>
        </div>
        <div className="mb2">
          {selectedVals.map((ev, i) => (
            <div
              className="mb2 d-flex fil-inputs"
              style={{ alignItems: "center" }}
            >
              <Select
                className="w25"
                placeholder="Select"
                options={getKeys(ev + i)}
                onChange={(e) => {
                  setSelectedType({
                    ...selectedType,
                    [e]: keys.find((ele) => ele.value === e).type,
                  });
                  setSelectedFil({
                    ...selectedFil,
                    [ev + i]: [e, i],
                  });
                }}
                value={selectedFil?.[ev + i]?.[0]}
              />
              <FilterInputs
                filters={selectedType}
                setFilterObj={setFilterObj}
                filtersObj={filters}
                ele={selectedFil?.[ev + i]?.[0]}
                index={i}
                remove={(idx) => {
                  let arr = [...selectedVals];
                  arr.splice(idx, 1);
                  setSelectedVals(arr);
                }}
                customized_data={cards?.data?.response?.customize_data}
              />
            </div>
          ))}
          <button
            className="add-btn"
            style={{ color: "var(--primary-blue)" }}
            onClick={() => {
              let arr = [...selectedVals];
              arr.push(1);
              setSelectedVals(arr);
            }}
          >
            + Add More
          </button>
        </div>

        <div>
          <button
            className="mr1 primary-btn"
            onClick={() => {
              let otherObj = {};
              if (location.pathname?.includes("cards")) {
                otherObj.card_only = true;
              }
              const filtersCopy = { ...filters };
              Object.keys(filtersCopy).forEach((key) => {
                if (Array.isArray(filtersCopy[key])) {
                  filtersCopy[key] = filtersCopy[key].join(",");
                }
              });
              dispatch(
                analytics_cards({
                  ...filtersCopy,
                  ...otherObj,
                  type: location.pathname?.includes("expenses")
                    ? "expenses"
                    : location.pathname?.includes("trips")
                    ? "trips"
                    : location.pathname?.includes("reports")
                    ? "reports"
                    : location.pathname.includes("advances")
                    ? "advances"
                    : "cards",
                })
              );
              dispatch(
                analytics_cards_all({
                  ...filtersCopy,
                  ...otherObj,
                  type: location.pathname?.includes("expenses")
                    ? "expenses"
                    : location.pathname?.includes("trips")
                    ? "trips"
                    : location.pathname?.includes("reports")
                    ? "reports"
                    : location.pathname.includes("advances")
                    ? "advances"
                    : "cards",
                  csv: true,
                })
              );
              setSelectExport(null);
            }}
            disabled={cards?.loading || Object.keys(filters).length === 0}
          >
            {cards?.loading ? "Loading..." : "Run Report"}
          </button>
          <button className="secondary-btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Reports;
